<template>
<div id="page-carga_ds">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Bitácora Informe" class="elevation-1 px-5 py-3">

                    <v-card-text>
                          <v-card >
                                <v-card class="pa-2 secondary white--text" style="margin-bottom:0px;">
                                    <v-icon small class="white--text">list</v-icon>&nbsp;
                                    Informes de Inventario Inicial
                                </v-card>
                                <v-card-text style="margin-top:0px;">
                                    <v-card-actions>
                                        <v-icon small color="blue">info</v-icon><small style="color:#2196F3;">Los informes con la fuente en <span style="color:red;">rojo</span> indican que no tiene archivo TXT</small><p/>

                                    <v-spacer></v-spacer>
                                    <v-speed-dial id="descargos_sd" direction="left" open-on-hover>
                                                <template v-slot:activator>
                                                    <v-btn id="descargos_sd_btn" x-small fab dark color="secondary" >
                                                        <v-icon>reorder</v-icon>
                                                    </v-btn>
                                                </template>


                                                <v-btn color="purple" fab x-small title="Información sobre Layout Fechas SAT" @click.native=" dialog_info = true" v-tippy>
                                                    <v-icon>mdi-help-circle-outline</v-icon>
                                                </v-btn>
                                                <exportar-excel :data="datafiltered1" :exportFields="inicial_excel" name="InventarioInicial.xlsx">
                                                    <v-btn color="green" fab x-small title="Descargar Información" v-tippy>
                                                    <v-icon  dark>mdi-table</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                <v-btn color="green" fab x-small title="Completar Información" @click.native=" dialog_info2i = true" v-tippy>
                                                    <v-icon>cloud_upload</v-icon>
                                                </v-btn>

                                        </v-speed-dial>
                                      </v-card-actions>



                            <v-client-table ref="vuetable1" :data="bitacora.items_inicial" :columns="columns_inicial" :options="options_inicial" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="valor_comercial" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial, 2)}}
                                    </div>
                                </template>

                                <template slot="esquema" slot-scope="props">
                                    <v-btn  color="blue" text x-small @click.native="editar_esquema(props.row)" >
                                      {{props.row.esquema}}
                                    </v-btn>
                                </template>

                                <template slot="error" slot-scope="props">
                                    <div style="text-align:center">
                                        <v-icon small v-if="props.row.error==0" color="green" title="Correcto" v-tippy>mdi-check-circle</v-icon>
                                        <v-icon small v-if="props.row.error==1" color="red" title="Con Errores" v-tippy>mdi-close-circle</v-icon>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id -1000" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                    <v-btn x-small fab dark color="green" @click.native="validarInicial(props.row)" title="Validar" v-tippy>
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark  color="purple" @click.native="editar_inicial(props.row)" title="Editar" v-tippy>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="primary" @click.native="downloadFile(props.row.key)" title="Descarga TXT" v-tippy>
                                        <v-icon>get_app</v-icon>
                                    </v-btn>

                                    <v-btn x-small fab dark color="blue" @click.native="getDetallesInicial(props.row)" title="Detalles" v-tippy>
                                        <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="red" @click.native="eliminar(props.row,'inventario')" title="Eliminar" v-tippy>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </v-speed-dial>
                                </template>
                            </v-client-table>
                        </v-card-text>
                            </v-card>
                        <hr/>

                            <v-card-text>
                            <v-card >
                                <v-card class="pa-2 primary white--text" style="margin-bottom:0px;">
                                    <v-icon small class="white--text">list</v-icon>&nbsp;
                                    Informes de Descargos
                                </v-card>
                                <v-card-text style="margin-top:0px;">
                                    <v-card-actions>
                                        <v-icon v-if="selecteds.length==0" small color="blue">info</v-icon><small v-if="selecteds.length==0" style="color:#2196F3;"> Si los informes de descargo no aparecen en el listado, revise en Simulación de Descargos (Informes TXT -> Bitacora Informe -> Simulación de Descargos)</small><p/>

                                        <!-- <v-btn v-if="selecteds.length>0" small color="secondary" @click.native="actualizarEstatus('Creado', '¿Está seguro que desea DESACTIVAR todos los registros seleccionados?')" title="Desactivar Seleccionados" v-tippy>
                                        <v-icon small >mdi-minus-circle</v-icon> Desactivar</v-btn>

                                        <v-btn  v-if="selecteds.length>0" small color="primary" @click.native="actualizarEstatus('Simulado', '¿Está seguro que desea SIMULAR todos los registros seleccionados?')" title="Simular Seleccionados" v-tippy>
                                        <v-icon small >mdi-check-decagram</v-icon> Simular</v-btn> -->

                                        <v-btn  v-if="selecteds.length>0" small color="red" @click.native="eliminarTodos( '¿Está seguro que desea ELIMINAR todos los registros seleccionados?')" title="Eliminar Seleccionados" v-tippy>
                                        <v-icon small >mdi-delete-clock</v-icon> Eliminar</v-btn>

                                        <v-btn  v-if="selecteds.length>0" small color="purple" @click.native="validarTodos( '¿Está seguro que desea VALIDAR todos los registros seleccionados?')" title="Validar Seleccionados" v-tippy>
                                        <v-icon small >mdi-check-all</v-icon> Validar</v-btn>

                                        <v-btn  v-if="selecteds.length>0 && planta_referencia" small color="green" @click.native="DescargarTodos( '¿Está seguro que desea DESCARGAR todos los registros seleccionados?')" title="Descargar Seleccionados" v-tippy>
                                        <v-icon small >mdi-download</v-icon> Descargar Consolidados</v-btn>
                                        <v-btn  v-if="selecteds.length>0 && planta_referencia" small color="blue" @click.native="DescargarPlantas( '¿Está seguro que desea DESCARGAR todos los registros seleccionados?')" title="Descargar Seleccionados" v-tippy>
                                        <v-icon small >mdi-download</v-icon> Descargar por Planta</v-btn>

                                        <v-btn  v-if="selecteds.length>0 && !planta_referencia" small color="green" @click.native="DescargarPlantas( '¿Está seguro que desea DESCARGAR todos los registros seleccionados?')" title="Descargar Seleccionados" v-tippy>
                                        <v-icon small >mdi-download</v-icon> Descargar</v-btn>

                                    <v-spacer></v-spacer>

                                    <v-speed-dial id="descargos_sd" direction="left" open-on-hover>
                                                <template v-slot:activator>
                                                    <v-btn id="descargos_sd_btn" x-small fab dark color="secondary" >
                                                        <v-icon>reorder</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-btn color="purple" fab x-small title="Información sobre Layout Fechas SAT" @click.native=" dialog_info = true" v-tippy>
                                                    <v-icon>mdi-help-circle-outline</v-icon>
                                                </v-btn>
                                                <exportar-excel :data="datafiltered2" :exportFields="des_excel" name="ReporteBitácoraInformesAplicados.xlsx">
                                                    <v-btn color="green" fab x-small title="Descargar Información" v-tippy>
                                                    <v-icon  dark>mdi-table</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                <v-btn color="green" fab x-small title="Completar Información" @click.native=" dialog_info2 = true" v-tippy>
                                                    <v-icon>cloud_upload</v-icon>
                                                </v-btn>



                                        </v-speed-dial>
                                      </v-card-actions>
                            <v-client-table ref="vuetable2" :data="bitacora.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>

                                <div slot="filter__id" >
                                    <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()"  >
                                </div>
                                <div v-if="planta_referencia" slot="filter__folio" style="min-width:175px;" id="ck_folio">

                                    <input type="checkbox" style="position:absolute; margin-top:-23px; margin-left:70px" v-model='soloC' title="Solo Consolidados" v-tippy @change="solo_c()" >
                                </div>
                                <template slot="id" slot-scope="props" >
                                    <div style="display:flex; justify-content:center;" >
                                    <input :id="props.row._id" type="checkbox" v-model="selecteds" :value="props.row._id" @change="acomoda_selecteds()" :disabled = "allChecked" />
                                    </div>
                                </template>

                                <template slot="folio" slot-scope="props">
                                    <div >
                                        {{props.row.folio}}<v-icon small v-if="props.row.consolidado.length>0" color="green" @click="open_consolidado(props.row);" title="Consolidado" v-tippy>mdi-table</v-icon>
                                        <small v-if="props.row.consolidado.length>0" style="color:green">{{ props.row.consolidado.length }}</small>
                                    </div>
                                </template>
                                <template slot="valor_comercial_final" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial_final, 2)}}
                                    </div>
                                </template>
                                <template slot="valor_comercial_calculado" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial_calculado, 2)}}
                                    </div>
                                </template>
                                <template slot="error" slot-scope="props">
                                    <div style="text-align:center">
                                        <v-icon small v-if="props.row.validado==1 && props.row.error==0" color="green" title="Correcto" v-tippy>mdi-check-circle</v-icon>
                                        <v-icon small v-if="props.row.validado==1 && props.row.error==1" color="red" title="Con Errores" v-tippy>mdi-close-circle</v-icon>
                                        <v-icon small v-if="props.row.validado==0" color="grey" title="Pendiente" v-tippy>mdi-clock-time-eight</v-icon>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="green" @click.native="validar(props.row)" title="Validar" v-tippy>
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark v-if="props.row.consolidado.length==0" color="purple" @click.native="editar(props.row)" title="Editar" v-tippy>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark v-if="props.row.consolidado.length>0" color="purple" @click.native="editar_c(props.row)" title="Editar" v-tippy>
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    <v-btn x-small fab dark color="primary" v-if="props.row.consolidado.length==0" @click.native="downloadFile(props.row.key)" title="Descarga TXT" v-tippy>
                                        <v-icon>get_app</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="primary" v-if="props.row.consolidado.length>0" @click.native="download_consolidado(props.row)" :href="myUrl" :download="myFilename" title="Descarga TXT Consolidado" v-tippy>
                                        <v-icon>get_app</v-icon>
                                    </v-btn>


                                    <v-btn x-small fab dark color="blue" @click.native="getDetalles(props.row)" title="Detalles" v-tippy>
                                        <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="red" @click.native="eliminar(props.row,'descargo')" title="Eliminar" v-tippy>
                                        <v-icon>delete</v-icon>
                                    </v-btn>

                                    <v-btn v-if="props.row.key_adjunto == '' || props.row.key_adjunto == null" x-small fab dark color="orange" @click.native="abrir_adjuntar(props.row._id)" title="Adjuntar Imagen" v-tippy>
                                        <v-icon>mdi-upload</v-icon>
                                    </v-btn>
                                    <v-btn v-else x-small fab dark color="secondary" @click.native="descargar_adjunto(props.row.key_adjunto)" title="Ver Imagen" v-tippy>
                                        <v-icon>image</v-icon>
                                    </v-btn>
                                    <v-btn v-if="props.row.key_adjunto != '' && props.row.key_adjunto != null" x-small fab dark color="red" @click.native="eliminar_adjunto(props.row._id)" title="Eliminar Imagen" v-tippy>
                                        <v-icon>mdi-image-remove</v-icon>
                                    </v-btn>
                                    </v-speed-dial>
                                </template>

                                <template slot="beforeTable">
                                  <div class="table-responsive" style="width:100%; justify-content:space-around; display:flex;, margin:5px !important; padding: 15px !important;">
                                    <div class="">
                                      <b>{{bitacora.items.length}} INFORMES DE DESCARGO CARGADOS A LA FECHA POR EL CONTRIBUYENTE</b>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div style="text-align: right;">
                                      <span v-if="false" ><b>Total Valor Comercial:</b> {{to_currency_decimal(total_cargos_calculado)}}</span><br> <!-- pide lourdes ocultar este -->
                                      <span><b>Total Valor Comercial del Descargo:</b> {{to_currency_decimal(total_cargos_final)}}</span>
                                    </div>
                                  </div>
                                </template>

                            </v-client-table>
                           </v-card-text>
                            </v-card>
                            <v-icon small color="blue">info</v-icon><small style="color:#2196F3;"> El valor TOTAL mostrado en las columnas de "Valor Comercial y Valor Descargado", se refiere a la suma de todos los informes integrados y en su caso a la clave que se muestre en el filtro de la columna "Destino Aduanero"</small><p/>

                    </v-card-text>

                    </v-card-text>
                </base-material-card>
                <v-dialog v-model="dialog" fullscreen>
                    <v-card v-if="registro.cabecera != undefined">

                        <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="dialog = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Informe de Descargo</strong>
                                        </span>
                                    </v-card>
                        </v-card-title>
                        <v-card-text align-center>

                            <v-simple-table dense class="table-striped">
                                <tbody>
                                    <tr >
                                        <th  style="width: 20%; text-align: right; vertical-align: middle;">Tipo Informe</th>
                                        <td>
                                            <div >02 - Informe de descargos</div>
                                        </td>
                                    </tr>
                                    <tr >
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Ejercicio</th>
                                        <td>
                                            <div >{{ registro.cabecera.ejercicio }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Destino Aduanero</th>
                                        <td>
                                            <div >{{  registro.cabecera.destino_aduanero }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Periodo Asociado</th>
                                        <td>
                                            <div >{{ registro.cabecera.periodo_asociado }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Archivo Cargado</th>
                                        <td>
                                            <div >{{ registro.nombre_original }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Informe a Sustituir</th>
                                        <td>
                                            <div ><span >{{registro.cabecera.numero_modificado}}</span></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Folio SAT</th>
                                        <td>
                                            <div >
                                                <div >{{ registro.folio }}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="registro.planta != ''" style="width: 20%; text-align: right; vertical-align: middle;">Planta</th>
                                        <td>
                                            <div >
                                                <div >{{ registro.planta }}</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table >
                            <v-client-table ref="vuetable_d1" :data="registro.detalles" :columns="registro.planta != ''?columns_detalles_planta:columns_detalles" :options="registro.planta != ''?options_detalles_planta:options_detalles" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="valor_comercial" slot-scope="props">
                                    <div class="text-number" v-if="props.row.tipo_infome!='04'">
                                        {{formatNumber(props.row.valor_comercial, 2)}}
                                    </div>
                                </template>

                                <template slot="errores" slot-scope="props">
                                    <div style="text-align:center">
                                        <v-icon small v-if="registro.validado==1 && props.row.errores==null" color="green" title="Correcto" v-tippy>mdi-check-circle</v-icon>
                                        <v-icon small v-if="registro.validado==1 && props.row.errores!=null" color="red" title="Con Errores" v-tippy>mdi-close-circle</v-icon>
                                        <v-icon small v-if="registro.validado==0" color="grey" title="Pendiente" v-tippy>mdi-clock-time-eight</v-icon>
                                        <span v-if="props.row.errores!=null" style="color:maroon"><small>{{props.row.errores}}</small></span>
                                    </div>
                                </template>
                            </v-client-table>

                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-btn color="green" @click="download_xlsx_descargo(registro.folio)">
                                DESCARCAR
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog = false">
                                CERRAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog2" fullscreen>
                    <v-card v-if="registro2.detalles != undefined">

                        <v-card-title>
                                    <v-card class="secondary white--text titulomodal" >
                                        <v-icon @click.native="dialog2 = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Inventario Inicial</strong>
                                        </span>
                                    </v-card>
                        </v-card-title>
                        <v-card-text align-center>

                            <v-simple-table dense class="table-striped">
                                <tbody>
                                    <tr >
                                        <th  style="width: 20%; text-align: right; vertical-align: middle;">Organización</th>
                                        <td>
                                            <div>{{ registro2.rfc }}</div>
                                        </td>
                                    </tr>
                                    <tr >
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Fecha</th>
                                        <td>
                                            <div >{{ registro2.fecha }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Usuario</th>
                                        <td>
                                            <div >{{  registro2.usuario }}</div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Archivo Cargado</th>
                                        <td>
                                            <div >{{ registro2.nombre_original }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">No. Movimiento</th>
                                        <td>
                                            <div ><span >{{registro2.consecutivo}}</span></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Informe a Sustituir</th>
                                        <td>
                                            <div ><span >{{registro2.reemplazo}}</span></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Folio SAT</th>
                                        <td>
                                            <div >
                                                <div >{{ registro2.folio }}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="planta_referencia">
                                        <th style="width: 20%; text-align: right; vertical-align: middle;">Planta-Referencia</th>
                                        <td>
                                            <div >
                                                <div >{{ registro2.planta }}</div>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </v-simple-table >
                            <v-client-table ref="vuetable_d2" :data="registro2.detalles" :columns="columns_detalles_iniciales" :options="options_detalles_iniciales" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="valor_comercial" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial, 2)}}
                                    </div>
                                </template>
                                <template slot="errores" slot-scope="props">
                                    <div style="text-align:center">
                                        <v-icon small v-if="props.row.errores==null" color="green" title="Correcto" v-tippy>mdi-check-circle</v-icon>
                                        <v-icon small v-if="props.row.errores!=null" color="red" title="Con Errores" v-tippy>mdi-close-circle</v-icon>

                                        <span v-if="props.row.errores!=null" style="color:maroon"><small>{{props.row.errores}}</small></span>

                                    </div>
                                </template>
                            </v-client-table>

                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-btn color="green" @click="download_xlsx(registro2.folio)">
                                DESCARCAR
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog2 = false">
                                CERRAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_edit" width="500px">
                    <v-card>

                        <v-card-title>
                                    <v-card class="purple white--text titulomodal" >
                                        <v-icon @click.native="dialog_edit = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Editar Descargo</strong>
                                        </span>
                                    </v-card>

                        </v-card-title>
                        <v-card-text align-center>
                            <p/>
                            <p/>
                              <v-text-field color="purple" filled background-color="#EEEEEE" dense readonly  label="Valor Comercial" type="text" hide-details  v-model="valor_edit" ></v-text-field>

                              <p/>
                            <p/>
                           <v-row  >
                            <v-col>
                                <v-text-field dense  name="cantidad_edit" label="Valor Comercial del Descargo" type="text" hide-details  v-model="cantidad_edit" ></v-text-field>
                            </v-col>
                            <v-col>
                            <v-select
                            :items="estados"
                            dense
                            label="Estatus"
                            v-model="estado_edit"

                            ></v-select>
                            </v-col>
                           </v-row>

                            <v-row  >
                            <v-col>
                                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" v-model="fecha_recepcion_edit" label="Fecha de Recepción" color="secondary" prepend-icon="event" @blur="fecha_recepcion_edit = parseDate(fecha_recepcion_edit)" v-mask="'####-##-##'"
                                      :rules="[]"></v-text-field>
                                  </template>

                                  <v-date-picker v-model="fecha_recepcion_edit" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                    <v-spacer />

                                    <v-btn color="secondary" x-small @click="menu1 = false">
                                      Cancelar
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                            </v-col>

                            </v-row>
                            <v-row>
                            <v-col>
                                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" v-model="fecha_validacion_edit" label="Fecha de Validación" color="secondary" prepend-icon="event" @blur="fecha_validacion_edit = parseDate(fecha_validacion_edit)" v-mask="'####-##-##'"
                                      :rules="[]"></v-text-field>
                                  </template>

                                  <v-date-picker v-model="fecha_validacion_edit" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                    <v-spacer />

                                    <v-btn color="secondary" x-small @click="menu2 = false">
                                      Cancelar
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col>

                                <v-select
                            :items="['Válido', 'No Válido']"

                            label="Estatus de Validación"
                            v-model="estatus_validacion_edit"

                            ></v-select>
                            </v-col>

                            </v-row>
                            <!-- <v-row>
                            <v-col>
                                <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" v-model="fecha_aplicacion_edit" label="Fecha de Aplicación" color="secondary" prepend-icon="event" @blur="fecha_aplicacion_edit = parseDate(fecha_aplicacion_edit)" v-mask="'####-##-##'"
                                      :rules="[]"></v-text-field>
                                  </template>

                                  <v-date-picker v-model="fecha_aplicacion_edit" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                                    <v-spacer />

                                    <v-btn color="secondary" x-small @click="menu3 = false">
                                      Cancelar
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>

                                <v-select
                            :items="['-','Válido', 'No Válido']"

                            label="Estatus de Aplicación"
                            v-model="estatus_aplicacion_edit"

                            ></v-select>
                            </v-col>

                            </v-row> -->
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog_edit = false">
                                CANCELAR
                            </v-btn>
                            <v-btn small color="primary"  @click="actualizar">
                                ACTUALIZAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_edit_inicial" width="500px">
                    <v-card>

                        <v-card-title>
                                    <v-card class="purple white--text titulomodal" >
                                        <v-icon @click.native="dialog_edit = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Editar Inventario Inicial</strong>
                                        </span>
                                    </v-card>

                        </v-card-title>
                        <v-card-text align-center>

                           <v-row  >
                            <v-col>
                                <v-text-field dense  name="folio_edit2" label="Folio SAT" type="text" hide-details  v-model="folio_edit2" ></v-text-field>
                            </v-col>
                            <v-col>

                            </v-col>
                           </v-row>

                            <v-row  >
                            <v-col>
                                <v-menu offset-x ref="menu1i" v-model="menu1i" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" v-model="fecha_recepcion_edit2" label="Fecha de Recepción" color="secondary" prepend-icon="event" @blur="fecha_recepcion_edit2 = parseDate(fecha_recepcion_edit2)" v-mask="'####-##-##'"
                                      :rules="[]"></v-text-field>
                                  </template>

                                  <v-date-picker v-model="fecha_recepcion_edit2" color="secondary" scrollable locale="es-mx" @input="menu1i = false">
                                    <v-spacer />

                                    <v-btn color="secondary" x-small @click="menu1i = false">
                                      Cancelar
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                            </v-col>

                            </v-row>
                            <v-row>
                            <v-col>
                                <v-menu offset-x ref="menu2i" v-model="menu2i" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" v-model="fecha_validacion_edit2" label="Fecha de Validación" color="secondary" prepend-icon="event" @blur="fecha_validacion_edit2 = parseDate(fecha_validacion_edit2)" v-mask="'####-##-##'"
                                      :rules="[]"></v-text-field>
                                  </template>

                                  <v-date-picker v-model="fecha_validacion_edit2" color="secondary" scrollable locale="es-mx" @input="menu2i = false">
                                    <v-spacer />

                                    <v-btn color="secondary" x-small @click="menu2i = false">
                                      Cancelar
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col>

                                <v-select
                            :items="['Válido', 'No Válido']"

                            label="Estatus de Validación"
                            v-model="estatus_validacion_edit2"

                            ></v-select>
                            </v-col>

                            </v-row>
                            <v-row>
                            <v-col>
                                <v-menu offset-x ref="menu3i" v-model="menu3i" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" v-model="fecha_aplicacion_edit2" label="Fecha de Aplicación" color="secondary" prepend-icon="event" @blur="fecha_aplicacion_edit2 = parseDate(fecha_aplicacion_edit2)" v-mask="'####-##-##'"
                                      :rules="[]"></v-text-field>
                                  </template>

                                  <v-date-picker v-model="fecha_aplicacion_edit2" color="secondary" scrollable locale="es-mx" @input="menu3i = false">
                                    <v-spacer />

                                    <v-btn color="secondary" x-small @click="menu3i = false">
                                      Cancelar
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>

                            </v-col>

                            </v-row>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog_edit_inicial = false">
                                CANCELAR
                            </v-btn>
                            <v-btn small color="primary"  @click="actualizar_inicial">
                                ACTUALIZAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_esquema" width="500px">
                    <v-card>

                        <v-card-title>
                                    <v-card class="secondary white--text titulomodal" >
                                        <v-icon @click.native="dialog_edit = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Editar Esquema de Certifiación</strong>
                                        </span>
                                    </v-card>

                        </v-card-title>
                        <v-card-text align-center>
                            <p/>
                            <p/>

                            <p/>
                            <v-select
                            :items="['Crédito', 'Garantía']"
                            dense
                            label="Esquema"
                            v-model="esquema_edit"

                            ></v-select>

                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog_esquema = false">
                                CANCELAR
                            </v-btn>
                            <v-btn small color="primary"  @click="actualizar_esquema">
                                ACTUALIZAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_info" width="750px">
                    <v-card>
                        <v-card-text align-center>
                        <center>
                            <img src="https://s3.amazonaws.com/descargas.econnectpro.mx/bitacora_info_1.png" alt="info" style="width:600px;" />


                        </center>
                        </v-card-text>
                        <v-card-actions style="margin-top:-50px;">
                            <v-spacer></v-spacer>
                            <v-btn small color="green" @click.native="download_layout('layoutInformacionSAT.xlsx');">
                                <v-icon  class="white--text" >get_app</v-icon>Descargar Plantilla..
                            </v-btn>
                            <v-btn small color="default"  @click="dialog_info = false">
                                <v-icon  class="white--text" >close</v-icon> Cerrar
                            </v-btn>
                        </v-card-actions>

                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_info2" width="750px">
                    <v-card>
                        <v-card-text align-center>
                        <center>
                            <img src="https://s3.amazonaws.com/descargas.econnectpro.mx/bitacora_info_1.png" alt="info" style="width:600px;" />

                        </center>
                        </v-card-text>
                        <v-card-actions style="padding:10px; margin-right:50px;">
                            <v-spacer></v-spacer>
                            <v-btn small color="default"  @click="dialog_info2 = false">
                                <v-icon  class="white--text" >close</v-icon>Cancelar
                            </v-btn>
                            <v-btn small color="green" @click.native="download_layout('layoutInformacionSAT.xlsx');">
                                <v-icon  class="white--text" >get_app</v-icon>Descargar Plantilla..
                            </v-btn>
                            <UploadExcel  title="Completar Información"  idInput="iniKey" @click.native=" dialog_info2 = false" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow="2" />
                        </v-card-actions>

                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_edit_c" width="500px">
                        <v-card>

                            <v-card-title>
                                        <v-card class="purple white--text titulomodal" >
                                            <v-icon @click.native="dialog_edit = false" class="white--text" >close</v-icon>&nbsp;
                                            <span class="subheading" >
                                                <strong>Editar Descargo Consolidado</strong>
                                            </span>
                                        </v-card>

                            </v-card-title>
                            <v-card-text align-center>

                               <v-row  >

                                <v-col>
                                <v-select
                                :items="estados"
                                dense
                                label="Estatus"
                                v-model="estado_edit"

                                ></v-select>
                                </v-col>
                               </v-row>

                                <v-row  >
                                <v-col>
                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                      <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="fecha_recepcion_edit" label="Fecha de Recepción" color="secondary" prepend-icon="event" @blur="fecha_recepcion_edit = parseDate(fecha_recepcion_edit)" v-mask="'####-##-##'"
                                          :rules="[]"></v-text-field>
                                      </template>

                                      <v-date-picker v-model="fecha_recepcion_edit" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu1 = false">
                                          Cancelar
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                </v-col>

                                </v-row>
                                <v-row>
                                <v-col>
                                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                      <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="fecha_validacion_edit" label="Fecha de Validación" color="secondary" prepend-icon="event" @blur="fecha_validacion_edit = parseDate(fecha_validacion_edit)" v-mask="'####-##-##'"
                                          :rules="[]"></v-text-field>
                                      </template>

                                      <v-date-picker v-model="fecha_validacion_edit" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu2 = false">
                                          Cancelar
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col>

                                    <v-select
                                :items="['Válido', 'No Válido']"

                                label="Estatus de Validación"
                                v-model="estatus_validacion_edit"

                                ></v-select>
                                </v-col>

                                </v-row>
                                <!-- <v-row> -->
                                <!-- <v-col>
                                    <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                      <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="fecha_aplicacion_edit" label="Fecha de Aplicación" color="secondary" prepend-icon="event" @blur="fecha_aplicacion_edit = parseDate(fecha_aplicacion_edit)" v-mask="'####-##-##'"
                                          :rules="[]"></v-text-field>
                                      </template>

                                      <v-date-picker v-model="fecha_aplicacion_edit" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu3 = false">
                                          Cancelar
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                </v-col> -->
                                <!-- <v-col>

                                    <v-select
                                :items="['-','Válido', 'No Válido']"

                                label="Estatus de Aplicación"
                                v-model="estatus_aplicacion_edit"

                                ></v-select>
                                </v-col> -->

                                <!-- </v-row> -->
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn small @click="dialog_edit_c = false">
                                    CANCELAR
                                </v-btn>
                                <v-btn small color="primary"  @click="actualizar_c">
                                    ACTUALIZAR
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                <v-dialog v-model="dialog_info2i" width="750px">
                    <v-card>
                        <v-card-text align-center>
                        <center>
                            <img src="https://s3.amazonaws.com/descargas.econnectpro.mx/bitacora_info_1.png" alt="info" style="width:600px;" />

                        </center>
                        </v-card-text>
                        <v-card-actions style="padding:10px; margin-right:50px;">
                            <v-spacer></v-spacer>
                            <v-btn small color="default"  @click="dialog_info2i = false">
                                <v-icon  class="white--text" >close</v-icon>Cancelar
                            </v-btn>
                            <v-btn small color="green" @click.native="download_layout('layoutInformacionSAT.xlsx');">
                                <v-icon  class="white--text" >get_app</v-icon>Descargar Plantilla..
                            </v-btn>
                            <UploadExcel  title="Completar Información"  idInput="desKey" @click.native=" dialog_info2i = false" :on-success="handleSuccess2" :before-upload="beforeUpload" :firstRow="2" />
                        </v-card-actions>

                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_consolidado" width="90%">
                    <v-card>
                        <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="dialog_consolidado = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Informe de Descargo {{ row.folio }}</strong>
                                        </span>
                                    </v-card>

                <v-card-text>
                <p/>
                    <v-client-table ref="vuetable3" :data="bitacora.consolidados" :columns="columns_planta" :options="options_planta" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="valor_comercial_final" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial_final, 2)}}
                                    </div>
                                </template>
                                <template slot="valor_comercial_calculado" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial_calculado, 2)}}
                                    </div>
                                </template>
                                <template slot="folio" slot-scope="props">
                                    <div style="text-align:center">
                                        {{props.row.folio.replace($local_storage.get("rfc"), props.row.planta_rfc)}}
                                    </div>
                                </template>
                                <template slot="error" slot-scope="props">
                                    <div style="text-align:center">
                                        <v-icon small v-if="props.row.validado==1 && props.row.error==0" color="green" title="Correcto" v-tippy>mdi-check-circle</v-icon>
                                        <v-icon small v-if="props.row.validado==1 && props.row.error==1" color="red" title="Con Errores" v-tippy>mdi-close-circle</v-icon>
                                        <v-icon small v-if="props.row.validado==0" color="grey" title="Pendiente" v-tippy>mdi-clock-time-eight</v-icon>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="green" @click.native="validar(props.row)" title="Validar" v-tippy>
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="purple" @click.native="editar(props.row)" title="Editar" v-tippy>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="primary" @click.native="downloadFile(props.row.key)" title="Descarga TXT" v-tippy>
                                        <v-icon>get_app</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="blue" @click.native="getDetalles(props.row)" title="Detalles" v-tippy>
                                        <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="red" @click.native="eliminar(props.row,'descargo')" title="Eliminar" v-tippy>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog_consolidado = false">
                                CANCELAR
                            </v-btn>

                        </v-card-actions>
                        </v-card>
                </v-dialog>

                <v-dialog v-model="dialog_adjunto" width="750px">
                  <v-card>
                    <v-card-title>
                      <v-card class="primary white--text titulomodal">
                        <v-icon class="white--text" @click.native="dialog_adjunto = false">cancel</v-icon>&nbsp;
                        <span class="subheading">
                          <strong>Adjuntar Imagen</strong>
                        </span>
                      </v-card>

                    </v-card-title>
                    <v-form ref="form_adjuntos" lazy-validation>
                      <v-card-text>
                        <br>
                        <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_adjunto">
                          <v-row row wrap>
                            <v-col class="d-flex" cols="12" sm="12">
                              <v-text-field label="Selecciona el archivo" @click='pickFile' v-model='model_adjunto.archivo.name' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                              <input type="file" style="display: none" ref="file_input" accept="image/jpeg, image/png" @change="onFilePicked">
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-form>
                    <v-card-actions>
                      <v-btn @click.native="dialog_adjunto = false;">
                        <v-icon>cancel</v-icon> Cancelar
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="success" :loading="loading" @click.native="guardar_adjunto">
                        <v-icon>done</v-icon>
                        Guardar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialog_img" width="750px" heigth="500">
                  <v-card>
                    <v-card-title>
                      <v-card class="primary white--text titulomodal">
                        <v-icon class="white--text" @click.native="dialog_img = false">cancel</v-icon>&nbsp;
                        <span class="subheading">
                          <strong>Adjunto</strong>
                        </span>
                      </v-card>

                    </v-card-title>
                    <v-container fluid grid-list-md text-xs-center style="padding: 15px !important; text-align: center;">
                        <img :src="url_img" width="500" height="400"/>
                    </v-container>
                    <v-card-actions>
                      <!-- <v-btn @click.native="dialog_img = false;">
                        <v-icon>cancel</v-icon> Cerrar
                      </v-btn> -->
                      <v-spacer></v-spacer>
                      <!-- <v-btn color="success" :loading="loading" @click.native="descargar_adjunto(null, true)">
                        <v-icon>mdi-download</v-icon>
                        Descargar
                      </v-btn> -->
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <LoaderFraces ref="fracesLoader" :mensajes="lista_mensajes" ></LoaderFraces>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import UploadExcel from '@/components/UploadExcel/UploadExcelInfo.vue';
import UploadExcel2 from '@/components/UploadExcel/UploadExcel.vue';
import LoaderFraces from "@/components/LoaderFraces";
import XLSX from 'xlsx';


export default {
    components: {
        "UploadExcel": UploadExcel,
        "UploadExcel2": UploadExcel2,
        LoaderFraces
     },
     watch: {

     },

    data() {
        return {
            lista_mensajes: [
                "ACTUALIZANDO FECHAS Y ESTATUS X NÚMEROS DE FOLIO",
                "VERIFICACIÓN DE NÚMEROS DE INFORME..",
            ],
            url_img:"",
            dialog_img:false,
            total_cargos_final:0,
            total_cargos_calculado:0,
            soloC: false,
            dialog_info: false,
            dialog_info2: false,
            dialog_edit_c: false,
            estados : ['Creado', 'Reemplazado', 'Simulado', 'Aplicado', 'No Válido'],
            id_editable:'',
            row:"",
            myUrl: '#',
            myFilename: '',
            dialog_consolidado: false,
            selecteds: [],
            los_folios: [],
            selecteds_acomodados:[],
            allChecked: false,
            menu1: false,
            menu2: false,
            menu3: false,
            menu1i: false,
            menu2i: false,
            menu3i: false,
            valor_edit:0,
            plantas:[],
            cantidad_edit:0,
            estado_edit:"",
            esquema_edit:"",
            fecha_recepcion_edit:"",
            fecha_validacion_edit:"",
            fecha_aplicacion_edit:"",
            estatus_validacion_edit: "",
            estatus_aplicacion_edit: "",
            fecha_recepcion_edit2:"",
            fecha_validacion_edit2:"",
            fecha_aplicacion_edit2:"",
            estatus_validacion_edit2: "",
            estatus_aplicacion_edit2: "",
            folio_edit2:"",
            dialog_edit: false,
            dialog_edit_inicial: false,
            dialog_esquema: false,
            dialog_info2i: false,
            fab: false,
            periodos: [],
            registro: "",
            registro2: "",
            tipos_documento:[],
            destinos_aduaneros:[],
            dialog: false,
            dialog2: false,
            name: "datagrid",
            columns_detalles: [
                'tipo_infome', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                'aduana', 'patente', 'pedimento', 'folio', 'errores'
            ],
            columns_detalles_planta: [
                'tipo_infome', 'planta', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                'aduana', 'patente', 'pedimento', 'folio', 'errores'
            ],
            columns_detalles_iniciales: [
                'tipo_infome',  'aduana', 'patente', 'pedimento', 'fecha_entrada', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                'folio', 'errores'
            ],
            options_detalles_iniciales: {
                filterable: [ 'tipo_infome',  'aduana', 'patente', 'pedimento', 'fecha_entrada', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                'folio', 'errores'
                ],
                sortable: ['tipo_infome',  'aduana', 'patente', 'pedimento', 'fecha_entrada', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                'folio', 'errores'
                ],

                headings: {
                    'tipo_infome': 'Tipo Informe	',
                    'fraccion_arancelaria': 'Fracción Arancelaria',
                    'valor_comercial': 'Valor Comercial	',

                    'identificador': 'Identificador',
                    'aduana': 'Aduana	',
                    'patente': 'Patente',
                    'pedimento': 'Pedimento	',
                    'folio': 'Informe a Sustituir	',
                    'fecha_entrada':'Fecha Entrada',
                    'errores': 'Indicador Verificado'
                }
            },
            options_detalles: {
                filterable: ['tipo_infome', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                    'aduana', 'patente', 'pedimento', 'folio', 'errores'
                ],
                sortable: ['tipo_infome', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                    'aduana', 'patente', 'pedimento', 'folio', 'errores'
                ],

                headings: {
                    'tipo_infome': 'Tipo Informe	',
                    'fraccion_arancelaria': 'Fracción Arancelaria',
                    'valor_comercial': 'Valor Comercial	',
                    'identificador': 'Identificador',
                    'aduana': 'Aduana	',
                    'patente': 'Patente',
                    'pedimento': 'Pedimento	',
                    'folio': 'Folio',
                    'errores': 'Indicador Verificado'
                }
            },
            options_detalles_planta: {
                filterable: ['tipo_infome', 'planta', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                    'aduana', 'patente', 'pedimento', 'folio', 'errores'
                ],
                sortable: ['tipo_infome', 'planta', 'fraccion_arancelaria', 'valor_comercial', 'identificador',
                    'aduana', 'patente', 'pedimento', 'folio', 'errores'
                ],

                headings: {
                    'tipo_infome': 'Tipo Informe	',
                    'planta': 'Planta/Referencia',
                    'fraccion_arancelaria': 'Fracción Arancelaria',
                    'valor_comercial': 'Valor Comercial	',
                    'identificador': 'Identificador',
                    'aduana': 'Aduana	',
                    'patente': 'Patente',
                    'pedimento': 'Pedimento	',
                    'folio': 'Folio',
                    'errores': 'Indicador Verificado'
                }
            },
            columns: [ 'id',
                'fecha', 'folio',
                'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                'fecha_aplicacion',  'valor_comercial_calculado', 'valor_comercial_final',
                'error', 'estatus',
                "actions"
            ],
            columns_planta: [ 'id',
                'fecha', 'folio', 'planta',
                'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                'fecha_aplicacion',  'valor_comercial_calculado', 'valor_comercial_final',
                'error', 'estatus',
                "actions"
            ],

            columns_inicial: [
                'fecha', 'folio', 'esquema', 'periodo', 'consecutivo',
                'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                'fecha_aplicacion', 'valor_comercial',
                'error',   "actions"
            ],
            options_inicial: {
                filterable: [ 'fecha', 'folio', 'esquema', 'periodo', 'consecutivo',
                'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                'fecha_aplicacion', 'valor_comercial',
                'error',
                ],
                sortable: [ 'fecha', 'folio', 'esquema', 'periodo', 'consecutivo',
                'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                'fecha_aplicacion', 'valor_comercial',
                'error',
                ],
                listColumns: {
                    error: [{
                            id: 0,
                            text: "Correctos"
                        },
                        {
                            id: 1,
                            text: "Con Errores"
                        },
                        {
                            id: 2,
                            text: "Pendientes"
                        },
                    ],
                    estatus: [{
                            id: 'Aplicado',
                            text: "Aplicado"
                        },
                        {
                            id: "Reemplazado",
                            text: "Reemplazado"
                        },
                        {
                            id: "Faltante",
                            text: "Faltante"
                        },
                        {
                            id: "No Válido",
                            text: "No Válido"
                        },
                    ]
                },
                headings: {
                    'fecha': 'Fecha Proceso SA31',
                    'folio': 'Folio SAT',
                    'periodo': 'Periodo Afectado',
                    'esquema':"Esquema de Certificación",
                    'consecutivo': 'No. Movimiento',
                    'fecha_recepcion': 'Fecha Recepción',
                    'fecha_validacion': 'Fecha Validación',
                    'estatus_validacion': 'Estatus de Validación',
                    'estatus_aplicacion': 'Estatus de Aplicación',
                    'fecha_aplicacion': 'Fecha Aplicación',
                    'valor_comercial': 'Valor Comercial',
                    'error': 'Indicador Verificado',
                    actions: "Funciones"
                }
            },
            inicial_excel: {
                'Fecha Proceso SA31':'fecha' ,
                'Folio SAT':  'folio' ,
                'Periodo Afectado':  'periodo' ,
                "Esquema de Certificación":  'esquema',
                'No. Movimiento':   'consecutivo' ,
                'Fecha Recepción':   'fecha_recepcion',
                'Fecha Validación':  'fecha_validacion' ,
                'Estatus de Validación':  'estatus_validacion' ,
                'Estatus de Aplicación':   'estatus_aplicacion' ,
                'Fecha Aplicación':   'fecha_aplicacion' ,
                'Valor Comercial':   'valor_comercial' ,
                },
            show_loading: true,
            options: {
                filterable: ['fecha', 'folio',
                    'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                    'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                    'fecha_aplicacion', 'valor_comercial_final', 'valor_comercial_calculado',
                    'error', 'estatus',
                ],
                sortable: ['fecha', 'folio',
                    'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                    'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                    'fecha_aplicacion', 'valor_comercial_final', 'valor_comercial_calculado',
                    'error', 'estatus',
                ],
                listColumns: {
                    error: [{
                            id: 0,
                            text: "Correctos"
                        },
                        {
                            id: 1,
                            text: "Con Errores"
                        },
                        {
                            id: 2,
                            text: "Pendientes"
                        },
                    ],
                    estatus: [
                      {
                        id:"",
                        text:"Todos",
                        default:true
                      },{
                            id: 'Aplicado',
                            text: "Aplicado"
                        },
                        {
                            id: "Reemplazado",
                            text: "Reemplazado"
                        },
                        {
                            id: "Faltante",
                            text: "Faltante"
                        },
                        {
                            id: "No Válido",
                            text: "No Válido"
                        },
                    ]
                },
                headings: {
                    'id':'',
                    'fecha': 'Fecha Proceso SA31',
                    'folio': 'Folio SAT',
                    'cabecera.destino_aduanero': 'Destino Aduanero',
                    'cabecera.ejercicio': 'Ejercicio',
                    'cabecera.periodo_asociado': 'Periodo Afectado',
                    'cabecera.consecutivo': 'No. Movimiento',
                    'fecha_recepcion': 'Fecha Recepción',
                    'fecha_validacion': 'Fecha Validación',
                    'estatus_validacion': 'Estatus de Validación',
                    'estatus_aplicacion': 'Estatus de Aplicación',
                    'fecha_aplicacion': 'Fecha Aplicación',
                    'valor_comercial_final': 'Valor Comercial del Descargo',
                    'valor_comercial_calculado': 'Valor Comercial',
                    'estatus': 'Estatus General',
                    'error': 'Indicador Verificado',
                    actions: "Funciones"
                }
            },
            des_excel: {
                'Fecha Proceso SA31':'fecha' ,
                'Folio SAT':  'folio' ,
                'Planta-Referencia': 'planta',
                'Destino Aduanero' : 'cabecera.destino_aduanero' ,
                'Ejercicio':  'cabecera.ejercicio',
                'Periodo Afectado':  'cabecera.periodo_asociado' ,
                'No. Movimiento':   'cabecera.consecutivo' ,
                'Fecha Recepción':   'fecha_recepcion',
                'Fecha Validación':  'fecha_validacion' ,
                'Estatus de Validación':  'estatus_validacion' ,
                'Estatus de Aplicación':   'estatus_aplicacion' ,
                'Fecha Aplicación':   'fecha_aplicacion' ,
                'Valor Comercial':   'valor_comercial_calculado' ,
                'Valor Comercial del Descargo' : 'valor_comercial_final' ,
                'Estatus': 'estatus'
                },
            options_planta: {
                filterable: false,
                sortable: ['fecha', 'folio', 'planta',
                    'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                    'fecha_recepcion', 'fecha_validacion', 'estatus_validacion',
                    'fecha_aplicacion', 'valor_comercial_final', 'valor_comercial_calculado',
                    'error', 'estatus',
                ],
                listColumns: {
                    error: [{
                            id: 0,
                            text: "Correctos"
                        },
                        {
                            id: 1,
                            text: "Con Errores"
                        },
                        {
                            id: 2,
                            text: "Pendientes"
                        },
                    ],
                    estatus: [{
                            id: 'Aplicado',
                            text: "Aplicado"
                        },
                        {
                            id: "Reemplazado",
                            text: "Reemplazado"
                        },
                        {
                            id: "Faltante",
                            text: "Faltante"
                        },
                        {
                            id: "No Válido",
                            text: "No Válido"
                        },
                    ]
                },
                headings: {
                    'id':'',
                    'fecha': 'Fecha Proceso SA31',
                    'folio': 'Folio SAT',
                    'planta': 'Planta-Referencia',
                    'cabecera.destino_aduanero': 'Destino Aduanero',
                    'cabecera.ejercicio': 'Ejercicio',
                    'cabecera.periodo_asociado': 'Periodo Afectado',
                    'cabecera.consecutivo': 'No. Movimiento',
                    'fecha_recepcion': 'Fecha Recepción',
                    'fecha_validacion': 'Fecha Validación',
                    'estatus_validacion': 'Estatus de Validación',
                    'estatus_aplicacion': 'Estatus de Aplicación',
                    'fecha_aplicacion': 'Fecha Aplicación',
                    'valor_comercial_final': 'Valor Comercial del Descargo',
                    'valor_comercial_calculado': 'Valor Comercial',
                    'estatus': 'Estatus',
                    'error': 'Indicador Verificado',
                    actions: "Funciones"
                }
            },
            show_loading: true,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Informes TXT",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Bitácora Informe",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            bitacora: {
                items: [],
                items_inicial: []
            },
            model_adjunto: {
              rfc:'',
              archivo:{},
              id:'',
            },
            dialog_adjunto:false,
            rules: {
              required: v => !!v || "Este campo es requerido"
            },
            loading:false
        };
    },

    methods: {
        abrir_adjuntar: function(id) {
            this.model_adjunto= {
              rfc:'',
              archivo:{},
              id:'',
            };
          this.model_adjunto.rfc = this.$local_storage.get("rfc");
          this.model_adjunto.id = id;
          this.dialog_adjunto = true;
        },
        descargar_adjunto: function(key, bajar=false) {
          if(bajar === true) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = this.url_img;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

            return;
          }
          this.url_img="";
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: key,
            bucket: "production.econnect.ds"
          }
          axios.post(this.$hostname + 's3/download_url/', datos)
            .then((res) => {
              if (typeof res.data !== 'undefined') {
                this.url_img=res.data.mensaje;
                this.dialog_img=true;

              } else {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                  footer: '',
                });
              }
            })
            .catch((error) => {
              var mensaje = "Ocurrió un error al descargar el archivo";
              if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                mensaje = error.response.data.mensaje;
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        },
        guardar_adjunto:async function(){
          if (!this.$refs.form_adjuntos.validate()) {
            return;
          }
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var mensaje = '';
          var status = '';
          let ext = this.model_adjunto.archivo.name.slice(-3);
          var keyBucket = this.model_adjunto.rfc + "/soluciona31/adjuntos/" + this.model_adjunto.id + "_imagen." + ext;
          var datos = {
              key: keyBucket,
              bucket: "production.econnect.ds",
              type: this.model_adjunto.archivo.type
          };

          await axios.post(this.$hostname + 's3/upload_url/', datos).then(async  (res) => {
            if (typeof res.data !== 'undefined') {
              var urlput = res.data.mensaje;
              var headers = {
                "headers": {
                  'Content-Type': this.model_adjunto.archivo.type
                }
              };

              await axios.put(urlput, this.model_adjunto.archivo, headers).then(async (res2) => {
                let formData = {
                  "rfc": this.model_adjunto.rfc,
                  "key": keyBucket,
                  "usuario": this.$local_storage.get('email')
                };

                await axios.post(this.$apiSA31 + 'soluciona31/agregar_adjunto/', formData).then((res3) => {
                  mensaje = 'La Imagen se adjunto correctamente.';
                  status = 'success';
                }).catch((error) => {
                  mensaje = 'Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.';
                  status = 'error';
                });
              }).catch((error2) => {
                  mensaje = 'Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.';
                  status = 'error';
              });
            } else {
              mensaje = 'Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.';
              status = 'error';
            }
          }).catch((error) => {
            mensaje = 'Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.';
            status = 'error';
          });

          this.$root.$dialogLoader.hide();
          this.dialog_adjunto=false;
          this.getBitacora();
          // this.model_adjunto = {
          //   rfc:'',
          //   archivo:{},
          //   id:'',
          // };
          this.$swal({
            type: status,
            title: "Resultado de la Operación",
            text: mensaje,
            footer: ""
          });
        },
        pickFile() {
          this.$refs.file_input.click()
        },
        onFilePicked(e) {
          try {
            const files = e.target.files;

            if (files[0] !== undefined) {
              this.model_adjunto.archivo = files[0]
            }
          } catch (error) {
            console.log(error);
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
              footer: ""
            });
            this.reset();
          }
        },
        remplazado(folio){

            let result = folio.substring(folio.length -2);
            if(parseInt(result)>1){
                result = result -1;
                if(result <10)
                	result = '0' + result;
                result = folio.substring(0, folio.length -2) + result ;
            }else{
            	result = "";
            }

            return result;
        },
        download_consolidado: async function(row) {
            let txt = "";
            let self = this;
            var rfc = this.$local_storage.get("rfc");
                    axios.post(this.$apiSA31 + "/soluciona31/consolidar_folio/", {
                            'folio': row.folio,
                            'rfc': rfc
                        })
                        .then(response => {

                          self.downloadFile(rfc + '/soluciona31/'+ row.folio + '_CONSOLIDADO.txt' )

                        })
                        .catch(error => {
                            self.$swal({
                                                    type: "error",
                                                    title: "Operación No Permitida",
                                                    text: "El archivo no puede ser validado",
                                                    footer: ""
                                                });
                        });



        },
        async actualizar_c(){
                let self = this;
                await Promise.all(self.id_editable.map(async (x) => {

                axios.post(this.$apiSA31  + "soluciona31/toggle_descargos/", {
                    'id':  x,
                    'estatus': self.estado_edit,
                    'fecha_recepcion': self.fecha_recepcion_edit != null && self.fecha_recepcion_edit != "" ? self.fecha_recepcion_edit+"T00:00:00" : null,
                    'fecha_validacion': self.fecha_validacion_edit != null && self.fecha_validacion_edit != "" ? self.fecha_validacion_edit+"T00:00:00" : null,
                    'fecha_aplicacion': self.fecha_aplicacion_edit != null && self.fecha_aplicacion_edit != "" ? self.fecha_aplicacion_edit+"T00:00:00" : null,
                    'estatus_validacion': self.estatus_validacion_edit,
                    'estatus_aplicacion': self.estatus_aplicacion_edit
                        })
                        .then(response => {


                        })
                        .catch(error => {
                            console.log(error);
                        });
                } ));
                self.getBitacora();
                self.dialog_edit_c = false;
                self.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El descargo se actualizó correctamente",
                        footer: ""
                    });

            },
        editar_c: function (row) {

            this.id_editable=row._id;

            this.estado_edit=row.consolidado[0].estatus;
            this.fecha_recepcion_edit = row.consolidado[0].fecha_recepcion;
            this.fecha_validacion_edit = row.consolidado[0].fecha_validacion;
            this.fecha_aplicacion_edit = row.consolidado[0].fecha_aplicacion;
            this.estatus_validacion_edit = row.consolidado[0].estatus_validacion;
            this.estatus_aplicacion_edit = row.consolidado[0].estatus_aplicacion;

            this.dialog_edit_c = true;
            },
       actualizar_esquema: function () {
            let self = this;
            var rfc = this.$local_storage.get("rfc");
            axios.post(this.$apiSA31  + "soluciona31/cambiar_esquema_inventario/", {
                'id':  this.id_editable,
                'rfc': rfc,
                'esquema': this.esquema_edit,
                    })
                    .then(response => {
                        this.getInicial();
                        this.dialog_esquema = false;
                        self.$swal({
                                        type: "success",
                                        title: "Operación Exitosa",
                                        text: "El Esquema se actualizó correctamente",
                                        footer: ""
                                    });
                    })
                    .catch(error => {
                        self.$swal({
                                        type: "error",
                                        title: "Operación No Permitida",
                                        text: "El Esquema no se actualizó intente nuevamente mas tarde.",
                                        footer: ""
                                    });
                    });
            },
        acomoda_selecteds(){
            let self = this;
            self.selecteds_acomodados = [];
            self.selecteds.forEach(function(x){
                if( Array.isArray(x)){
                    self.selecteds_acomodados = self.selecteds_acomodados.concat(x);
                }else{
                    self.selecteds_acomodados.push(x);
                }

            });
        },
        check_all: function() {
            let arr = this.allChecked ? this.datafiltered2.map(row =>  row._id) : [];

            if (arr.length == 0) {
                this.selecteds = [];
            } else {
                for (var i = 0; i < arr.length; i++) {
                if (this.selecteds.includes(arr[i])) {
                    continue;
                } else {
                  this.selecteds.push(arr[i]);
                }
                }
            }
            this.acomoda_selecteds();
        },
        solo_c: function() {

                if(this.soloC){
                    this.bitacora.items = this.bitacora.items.filter(item => {
                          return item.consolidado.length > 0
                     });
                }else{
                    this.getBitacora()
                }

        },
        open_consolidado: function(row) {
            this.dialog_consolidado=true;
            this.bitacora.consolidados = row.consolidado;
            this.row = row;
        },

        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        beforeUpload(file) {

            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            let self = this;
            var errores = 0;
            var erroresText = '';
            let importData = [];
            var rfc = this.$local_storage.get("rfc");
            try {
                this.$refs.fracesLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    console.log(results);
                    var errores_fechas = "";

                    results.forEach(function(x){
                        let fecha_r = moment(String(self.parseDateExcel(x['Fecha Recepción'])));
                        let fecha_v = moment(String(self.parseDateExcel(x['Fecha Validacion'])));

                        let now = moment(new Date());

                        if(moment(fecha_r).isAfter(now) || moment(fecha_v).isAfter(now)){
                          errores_fechas += "Fecha mayor al día actual en el Folio: " + x['Folio'] + ".\n"
                        }

                        importData.push({
                            'folio': x['Folio'],
                            'fecha_recepcion': self.parseDateExcel(x['Fecha Recepción']),
                            'fecha_validacion':self.parseDateExcel(x['Fecha Validacion']),
                            'fecha_aplicacion':self.parseDateExcel(x['Fecha Aplicación']) === false ? null : self.parseDateExcel(x['Fecha Aplicación']),
                            'estatus_validacion':self.validar_estatus(x['Estatus Validación']),
                            'estatus_aplicacion': x['Estatus Aplicación'] == undefined? "-" :x['Estatus Aplicación'] ,
                        });

                    });

                    if(errores_fechas !== "") {
                        this.$refs.fracesLoader.hide();

                      this.$swal({
                          type: "info",
                          title: "¡Operación no Permitida!",
                          text: "Registros Incorrectos. Verifique el contenido del archivo",
                          footer: errores_fechas
                      });

                      return;
                    }

                    let data = {
                        'rfc': rfc,
                        'rows': importData
                    }
                    axios
                        .post(this.$apiSA31  + "/soluciona31/completar_informe_descargo/", data)
                        .then(response => {
                           if(response.data.length > 0){
                               let mensaje = "";
                               response.data.forEach(function(x){
                                   mensaje += "<li>" + x.folio + " " +x.error + "</li>";
                               });
                               this.$swal({
                               type: "error",
                               title: "¡Operación no Permitida!",
                               html: "<pre><small>" + mensaje + "</small></pre>",
                               footer:  ""
                           });

                           }else{
                               this.$swal({
                               type: "success",
                               title: "¡Operación Exitosa!",
                               text: "Los datos se guardaron correctamente",
                               footer: ""
                           });
                           }

                       })
                        .catch(err => {
                            var errores = "";
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Error al cargar el archivo. Verifique el contenido del archivo",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.getBitacora();
                            this.$refs.fracesLoader.hide();
                        });


            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique el contenido del archivo",
                    footer: error.message,
                });
                this.$refs.fracesLoader.hide();
            }
        },
        validar_estatus: function(estatus) {
            var dict = {
              "Válido": ["valido", "válido"],
              "No Válido": ["no valido", "no válido"],
              "Validado": ["validado"],
              "No procesado": ["no procesado"]
            };

            var flag = false;

            for(var x in dict) {
                if(dict[x].includes(estatus.toLowerCase().trim())) {
                flag = x;
                break;
              }
            }

            if(flag == false) {
              return "N/A";
            } else {
              return flag;
            }

        },
        handleSuccess2: async function ({
            results,
            header
        }) {
            let self = this;
            var errores = 0;
            var erroresText = '';
            let importData = [];
            var rfc = this.$local_storage.get("rfc");
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    console.log(results);
                    var errores_fechas = "";

                    results.forEach(function(x){
                      let fecha_r = moment(String(self.parseDateExcel(x['Fecha Recepción'])));
                      let fecha_v = moment(String(self.parseDateExcel(x['Fecha Validacion'])));

                      let now = moment(new Date());

                      if(moment(fecha_r).isAfter(now) || moment(fecha_v).isAfter(now)){
                        errores_fechas += "Fecha mayor al día actual en el Folio: " + x['Folio'] + ".\n"
                      }

                        importData.push({
                            'folio': x['Folio'],
                            'fecha_recepcion': self.parseDateExcel(x['Fecha Recepción']),
                            'fecha_validacion':self.parseDateExcel(x['Fecha Validacion']),
                            'fecha_aplicacion':self.parseDateExcel(x['Fecha Aplicación']) === false ? null : self.parseDateExcel(x['Fecha Aplicación']),
                            'estatus_validacion':self.validar_estatus(x['Estatus Validación']),
                            'estatus_aplicacion': x['Estatus Aplicación'] == undefined? "-" :x['Estatus Aplicación'] ,
                        });

                    });

                    if(errores_fechas !== "") {
                      this.$root.$dialogLoader.hide();

                      this.$swal({
                          type: "info",
                          title: "¡Operación no Permitida!",
                          text: "Registros Incorrectos. Verifique el contenido del archivo",
                          footer: errores_fechas
                      });

                      return;
                    }

                    let data = {
                        'rfc': rfc,
                        'rows': importData
                    }
                    axios
                        .post(this.$apiSA31  + "/soluciona31/completar_inventario_inicial/", data)
                        .then(response => {


                            if(response.data.length > 0){
                                let mensaje = "";
                                response.data.forEach(function(x){
                                    mensaje += "<li>" + x.folio + " " +x.error + "</li>";
                                });
                                this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                html: "<pre><small>" + mensaje + "</small></pre>",
                                footer:  ""
                            });

                            }else{
                                this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                            }

                        })
                        .catch(err => {
                            var errores = "";
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Error al cargar el archivo. Verifique el contenido del archivo",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.getInicial();
                            this.$root.$dialogLoader.hide();
                        });


            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique el contenido del archivo",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        parseDate(date) {
          //Formato  YYYY-MM-DD
          if (!date) return null;
          return moment(String(date)).format("YYYY-MM-DD");
        },
        editar: function (row) {

            this.id_editable=row._id;
            this.valor_edit=row.valor_comercial_calculado;
            this.cantidad_edit=row.valor_comercial_final;
            this.estado_edit=row.estatus;
            this.fecha_recepcion_edit = row.fecha_recepcion;
            this.fecha_validacion_edit = row.fecha_validacion;
            this.fecha_aplicacion_edit = row.fecha_aplicacion;
            this.estatus_validacion_edit = row.estatus_validacion;
            this.estatus_aplicacion_edit = row.estatus_aplicacion;

            this.dialog_edit = true;
        },
        editar_inicial: function (row) {

            this.id_editable=row._id;
            this.folio_edit2 = row.folio;
            this.fecha_recepcion_edit2 = row.fecha_recepcion;
            this.fecha_validacion_edit2 = row.fecha_validacion;
            this.fecha_aplicacion_edit2 = row.fecha_aplicacion;
            this.estatus_validacion_edit2 = row.estatus_validacion;
            this.estatus_aplicacion_edit2 = row.estatus_aplicacion;

            this.dialog_edit_inicial = true;
         },
        editar_esquema: function (row) {
           console.log(row);
           this.id_editable=row._id;
           this.esquema_edit=row.esquema;
           this.dialog_esquema = true;
       },
        actualizar: async function () {
            let self = this;
           await axios.post(this.$apiSA31  + "soluciona31/toggle_descargos/", {
                'id':  this.id_editable,
                'estatus': this.estado_edit,
                'valor_comercial_final': this.cantidad_edit,
                'fecha_recepcion': this.fecha_recepcion_edit != null && this.fecha_recepcion_edit != "" ? this.fecha_recepcion_edit+"T00:00:00" : null,
                'fecha_validacion': this.fecha_validacion_edit != null && this.fecha_validacion_edit != "" ? this.fecha_validacion_edit+"T00:00:00" : null,
                'estatus_validacion': this.estatus_validacion_edit,
                'estatus_aplicacion': this.estatus_aplicacion_edit
                    })
                    .then(response => {
                        this.getBitacora();
                        this.dialog_edit = false;
                        self.$swal({
                                        type: "success",
                                        title: "Operación Exitosa",
                                        text: "El descargo se actualizó correctamente",
                                        footer: ""
                                    });
                    })
                    .catch(error => {
                        self.$swal({
                                        type: "error",
                                        title: "Operación No Permitida",
                                        text: "El descargo no se actualizó intente nuevamente mas tarde.",
                                        footer: ""
                                    });
                    });
        },
        actualizar_inicial: async function () {
            let self = this;
           await axios.post(this.$apiSA31  + "soluciona31/update_inventario_inicial/", {
                'id':  this.id_editable,
                'folio':this.folio_edit2,
                'fecha_recepcion': this.fecha_recepcion_edit2 != null && this.fecha_recepcion_edit2 != "" ? this.fecha_recepcion_edit2: null,
                'fecha_validacion': this.fecha_validacion_edit2 != null && this.fecha_validacion_edit2 != "" ? this.fecha_validacion_edit2 : null,
                'fecha_aplicacion': this.fecha_aplicacion_edit2 != null && this.fecha_aplicacion_edit2 != "" ? this.fecha_aplicacion_edit2 : null,
                'estatus_validacion': this.estatus_validacion_edit2,
                'estatus_aplicacion': this.estatus_aplicacion_edit2
                    })
                    .then(response => {
                        this.getInicial();
                        this.dialog_edit_inicial = false;
                        self.$swal({
                                        type: "success",
                                        title: "Operación Exitosa",
                                        text: "El descargo se actualizó correctamente",
                                        footer: ""
                                    });
                    })
                    .catch(error => {
                        self.$swal({
                                        type: "error",
                                        title: "Operación No Permitida",
                                        text: "El descargo no se actualizó intente nuevamente mas tarde.",
                                        footer: ""
                                    });
                    });
        },
        actualizar_esquema: function () {
            let self = this;
            var rfc = this.$local_storage.get("rfc");
            axios.post(this.$apiSA31  + "soluciona31/cambiar_esquema_inventario/", {
                'id':  this.id_editable,
                'rfc': rfc,
                'esquema': this.esquema_edit,
                    })
                    .then(response => {
                        this.getInicial();
                        this.dialog_esquema = false;
                        self.$swal({
                                        type: "success",
                                        title: "Operación Exitosa",
                                        text: "El Esquema se actualizó correctamente",
                                        footer: ""
                                    });
                    })
                    .catch(error => {
                        self.$swal({
                                        type: "error",
                                        title: "Operación No Permitida",
                                        text: "El Esquema no se actualizó intente nuevamente mas tarde.",
                                        footer: ""
                                    });
                    });
        },
        eliminarTodos: async function (msg) {
           let self = this;
           var rfc = this.$local_storage.get("rfc");
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           let msg2 = "¿Está seguro que desea ELIMINAR " + self.selecteds.length + " registros seleccionados?";
           if(self.selecteds_acomodados.length == 1)
             msg2 = "¿Está seguro que desea ELIMINAR " + self.selecteds.length + " registro seleccionado?";


           self.$swal({
                type: "info",
                title: "Cuidado",
                text: msg2,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                   // self.selecteds.forEach(function(x){

                //   await Promise.all(self.selecteds_acomodados.map(async (x) => {
                      await axios.post(self.$apiSA31 + "/soluciona31/eliminar_informe_masivo/", {
                            'ids': self.selecteds_acomodados,
                            'rfc': rfc,
                            'tipo': 'descargo',
                            'usuario': self.$local_storage.get("email"),
                        })
                            .then(response => {
                                self.getBitacora();
                                self.$root.$dialogLoader.hide();
                                self.$swal({
                                                type: "success",
                                                title: "Operación Exitosa",
                                                text: "Los registros se eliminaron correctamente",
                                                footer: ""
                                            });
                                        })
                            .catch(error => {

                            });
                   // }));

                  }else{
                    self.$root.$dialogLoader.hide();
                  }
            });


        },
        DescargarPlantas: function (msg) {
           let self = this;
           var rfc = this.$local_storage.get("rfc");
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           self.$swal({
                type: "info",
                title: "Cuidado",
                text: msg,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {

                    await this.acomoda_selecteds();
                    await axios.post(self.$apiSA31 + "soluciona31/reportes/get_zip_folios/", {
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("id_usuario"),
                            'ids': self.selecteds_acomodados
                        })
                            .then(response => {
                                self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "La peticion se envio correctamente",
                                    footer: "En breve recibira una notificación"
                                });
                            })
                            .catch(error => {

                            });
                    self.$root.$dialogLoader.hide();

                  }else{
                            self.$root.$dialogLoader.hide();
                        }
            });


        },
        DescargarTodos: function (msg) {
           let self = this;
           var rfc = this.$local_storage.get("rfc");
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           self.$swal({
                type: "info",
                title: "Cuidado",
                text: msg,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                   // self.selecteds.forEach(function(x){

                   let self = this;
                    self.los_folios = [];
                    self.selecteds.forEach(function(x){
                        if( Array.isArray(x)){
                                console.log(x[0]);
                                let p = self.bitacora.todos.filter(item => {
                                    return item._id == x[0]
                                });
                                if (p.length > 0) {
                                    console.log(p);
                                    self.los_folios.push({'folio':p[0].folio, 'consolidado':1}) ;
                                }

                        }else{
                            let q = self.bitacora.todos.filter(item => {
                                    return item._id == x
                                });
                                if (q.length > 0) {
                                    self.los_folios.push({'folio':q[0].folio, 'consolidado':0}) ;
                                }
                        }

                    });


                       await axios.post(self.$apiSA31 + "soluciona31/reportes/get_zip_consolidados/", {
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("id_usuario"),
                            'folios': self.los_folios
                        })
                            .then(response => {
                                self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "La peticion se envio correctamente",
                                    footer: "En breve recibira una notificación"
                                });
                            })
                            .catch(error => {

                            });

                    self.$root.$dialogLoader.hide();

                  }else{
                            self.$root.$dialogLoader.hide();
                        }
            });


        },
        actualizarEstatus: function (estatus, msg) {
           let self = this;
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           self.$swal({
                type: "info",
                title: "Cuidado",
                text: msg,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    await this.acomoda_selecteds();
                  await  Promise.all(self.selecteds_acomodados.map(async (x) => {
                 //   self.selecteds.forEach(function(x){
                     await  axios.post(self.$apiSA31  + "soluciona31/toggle_descargos/", {
                        'id':  x,
                        'estatus': estatus,
                            })
                            .then(response => {

                            })
                            .catch(error => {

                            });
                    }));
                    self.getBitacora();
                    self.$root.$dialogLoader.hide();
                    self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "La acción finalizo correctamente",
                                    footer: ""
                                });
                  }else{
                            self.$root.$dialogLoader.hide();
                        }
            });


        },
        validarTodos: function (msg) {
           let self = this;
           var rfc = this.$local_storage.get("rfc");
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           self.$swal({
                type: "info",
                title: "Cuidado",
                text: msg,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    await this.acomoda_selecteds();
                  await  Promise.all(self.selecteds_acomodados.map(async (x) => {
                   // self.selecteds.forEach(function(x){

                       await axios.post(self.$apiSA31 + "/soluciona31/validar_detalles_descargo/", {
                            'id': x,
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("email")
                        })
                            .then(response => {

                            })
                            .catch(error => {

                            });
                    }));
                    self.getBitacora();
                    self.$root.$dialogLoader.hide();
                    self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "Los registros se validaron correctamente",
                                    footer: ""
                                });
                  }else{
                    self.$root.$dialogLoader.hide();
                  }
            });


        },
        getBitacora: function () {
            let self = this;
            this.total_cargos_final = 0;
            this.total_cargos_calculado = 0;

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc");
            this.selecteds = [];
            axios.post(this.$apiSA31 + "soluciona31/list_informes_descargo/", {
                    'rfc': rfc,
                   'campos':{'fecha':1, 'folio':1, 'cabecera':1, 'fecha_recepcion':1, 'fecha_validacion':1, 'estatus_validacion':1,
                    'fecha_aplicacion':1, 'estatus_aplicacion':1, 'valor_comercial_final':1, 'valor_comercial_calculado':1,
                    'error':1, 'estatus':1, 'key':1 , 'planta':1, 'validado':1, 'key_adjunto':1
                     },
                     filtros: {"estatus": {"$in": ['Reemplazado',  'Aplicado',  'Faltante',   'No Válido']}},
                })
                .then(response => {
                    this.bitacora.items = response.data;
                    this.bitacora.todos = response.data;
                    let folio = '';
                    let aux = [];
                    for (var k in this.bitacora.items) {
                        this.total_cargos_final += this.bitacora.items[k].total_valor_comercial_final;
                        this.total_cargos_calculado += this.bitacora.items[k].total_valor_comercial_calculado;
                        this.bitacora.items[k].fecha = moment(String(this.bitacora.items[k].fecha)).format("YYYY-MM-DD");

                        this.bitacora.items[k].fecha_recepcion = moment(String(this.bitacora.items[k].fecha_recepcion)).format("YYYY-MM-DD");
                        if (this.bitacora.items[k].fecha_recepcion == 'Invalid date') this.bitacora.items[k].fecha_recepcion = ' ';

                        this.bitacora.items[k].fecha_validacion = moment(String(this.bitacora.items[k].fecha_validacion)).format("YYYY-MM-DD");
                        if (this.bitacora.items[k].fecha_validacion == 'Invalid date') this.bitacora.items[k].fecha_validacion = ' ';

                        this.bitacora.items[k].fecha_aplicacion = moment(String(this.bitacora.items[k].fecha_aplicacion)).format("YYYY-MM-DD");
                        if (this.bitacora.items[k].fecha_aplicacion == 'Invalid date') this.bitacora.items[k].fecha_aplicacion = ' ';

                        if (this.bitacora.items[k].validado == 0)
                            this.bitacora.items[k].error = 2;

                        let periodo = this.bitacora.items[k].cabecera.periodo_asociado;
                        this.bitacora.items[k].cabecera.periodo_clave = periodo;
                        let p = this.periodos.filter(item => {
                            return item.clave == periodo
                        });
                        if (p.length > 0) {
                            this.bitacora.items[k].cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                        }


                    }

                    // self.bitacora.items.sort(function (a, b) {
                    //     //Ordenar por fecha más reciente
                    //     return (b.cabecera.ejercicio) + '-' + b.cabecera.periodo_clave > a.cabecera.ejercicio + '-' + a.cabecera.periodo_clave;
                    // });


                    for (var j in self.bitacora.items) {
                       if(self.bitacora.items[j].planta == ""){
                            self.bitacora.items[j].consolidado = [];
                            aux.push(self.bitacora.items[j]);
                       }else{

                            if(folio != self.bitacora.items[j].folio){
                                    folio = self.bitacora.items[j].folio;

                                    let c = self.bitacora.items.filter(item => {
                                        return item.folio == folio && item.planta != ""
                                    });
                                    let con = {};

                                    let arr = [];
                                    let total_valor_comercial_final = 0;
                                    let total_valor_comercial_calculado = 0;
                                    let ids= [];
                                    let validado_consolidado = 0;
                                    let error_consolidado = 0;

                                    let e_error_consolidado = 0;
                                    let e_faltan_consolidado = 0;
                                    c.forEach(function(x){
                                        let planta = self.plantas.filter(item => {
                                            return item.referencia == x.planta
                                        });
                                        let planta_nombre = "";
                                        let planta_rfc = "";
                                        if (planta.length > 0) {
                                            planta_nombre = planta[0].nombre;
                                            planta_rfc = planta[0].rfc;
                                        }
                                        con = {
                                                "_id": "",
                                                "fecha": x.fecha,
                                                "fecha_recepcion": x.fecha_recepcion,
                                                "fecha_validacion": x.fecha_validacion,
                                                "estatus_validacion": x.estatus_validacion,
                                                "fecha_aplicacion": x.fecha_aplicacion,
                                                "estatus_aplicacion": x.estatus_aplicacion,
                                                "valor_comercial_final": 0,
                                                "valor_comercial_calculado": 0,
                                                "error": 0,
                                                "estatus": x.estatus,
                                                "folio": x.folio,
                                                "key": "",
                                                "consolidado": [],
                                                "cabecera": {
                                                    "destino_aduanero": x.cabecera.destino_aduanero,
                                                    "ejercicio": x.cabecera.ejercicio,
                                                    "periodo_asociado": x.cabecera.periodo_asociado,
                                                    "numero_modificado": x.cabecera.numero_modificado,
                                                    "error": 0,
                                                    "consecutivo": x.cabecera.consecutivo,
                                                    "periodo_clave": x.cabecera.periodo_clave
                                                },
                                                "planta": "",


                                            };
                                            total_valor_comercial_final +=  parseFloat(x.valor_comercial_final) ;
                                            total_valor_comercial_calculado += parseFloat(x.valor_comercial_calculado) ;
                                            x.consolidado = [];
                                            x.planta_nombre = planta_nombre;
                                            x.planta_rfc = planta_rfc;
                                            if ( x.validado==1 && x.error==0 ){
                                                    validado_consolidado = 1;
                                                    error_consolidado = 0;
                                               }
                                               if ( x.validado==1 && x.error==1 ){
                                                    e_error_consolidado = 1;
                                               }
                                               if ( x.validado==0  ){
                                                    e_faltan_consolidado = 1;
                                               }

                                            ids.push(x._id) ;
                                            arr.push(x);
                                    });
                                    con.consolidado = arr;
                                    con.valor_comercial_final = total_valor_comercial_final;
                                    con.valor_comercial_calculado = total_valor_comercial_calculado;
                                    con.validado = validado_consolidado;

                                    if(e_error_consolidado== 1)
                                        con.error = 1;
                                    else
                                        con.error = error_consolidado;

                                    if(e_faltan_consolidado== 1)
                                        con.validado = 0;

                                    con._id = ids;
                                    aux.push(con);
                             }


                       }



                    }
                    this.bitacora.items =  aux;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },
        getInicial: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc");
            axios.post(this.$apiSA31 + "soluciona31/list_inventarios_iniciales/", {
                    'rfc': rfc,
                      'campos':{'fecha':1, 'folio':1, 'esquema':1, 'periodo':1, 'consecutivo':1,  'fecha_recepcion':1, 'fecha_validacion':1, 'estatus_validacion':1,
                    'fecha_aplicacion':1, 'estatus_aplicacion':1, 'valor_comercial':1,  'error':1,  'key':1, 'reemplazo':1
                 }
                })
                .then(response => {
                    this.bitacora.items_inicial = response.data;

                    for (var k in this.bitacora.items_inicial) {
                        this.bitacora.items_inicial[k].fecha = moment(String(this.bitacora.items_inicial[k].fecha)).format("YYYY-MM-DD");

                        this.bitacora.items_inicial[k].fecha_recepcion = moment(String(this.bitacora.items_inicial[k].fecha_recepcion)).format("YYYY-MM-DD");
                        if (this.bitacora.items_inicial[k].fecha_recepcion == 'Invalid date') this.bitacora.items_inicial[k].fecha_recepcion = ' ';

                        this.bitacora.items_inicial[k].fecha_validacion = moment(String(this.bitacora.items_inicial[k].fecha_validacion)).format("YYYY-MM-DD");
                        if (this.bitacora.items_inicial[k].fecha_validacion == 'Invalid date') this.bitacora.items_inicial[k].fecha_validacion = ' ';

                        this.bitacora.items_inicial[k].fecha_aplicacion = moment(String(this.bitacora.items_inicial[k].fecha_aplicacion)).format("YYYY-MM-DD");
                        if (this.bitacora.items_inicial[k].fecha_aplicacion == 'Invalid date') this.bitacora.items_inicial[k].fecha_aplicacion = ' ';

                        // let periodo = this.bitacora.items_inicial[k].cabecera.periodo_asociado;
                        // let p = this.periodos.filter(item => {
                        //     return item.clave == periodo
                        // });
                        // if (p.length > 0) {
                        //     this.bitacora.items_inicial[k].cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                        // }

                    }
                    this.bitacora.items_inicial.sort(function (a, b) {
                        //Ordenar por fecha más reciente
                        return new(b.fecha) - (a.fecha);
                    });

                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {

                    this.$root.$dialogLoader.hide();
                });
        },
        getPeriodos: function () {

            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 32
                })
                .then(response => {

                    this.periodos = response.data;
                    this.getTiposDocumento();
                    this.getDestinosAduaneros();
                    this.getBitacora();
                    this.getInicial();

                })
                .catch(error => {

                });
        },
        cargarPlantas: function () {
            let data = {
                cliente: this.$local_storage.get("id_cliente"),
            };
            axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.plantas = res.data;

                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getTiposDocumento: function () {

                axios.post(this.$hostname + "apendices/lista/", {
                        'tabla': 31
                    })
                    .then(response => {
                        this.tipos_documento = response.data;
                    })
                    .catch(error => {

                    });
                },
        getDestinosAduaneros: function () {

                axios.post(this.$hostname + "apendices/lista/", {
                        'tabla': 30
                    })
                    .then(response => {
                        this.destinos_aduaneros = response.data;
                    })
                    .catch(error => {

                    });
        },
        getDetalles: function (row) {
            let self = this;
            var rfc = this.$local_storage.get("rfc");
            let detalles =[];
            let plantas = " | ";
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            if( Array.isArray(row._id)){

                Promise.all(row._id.map(async (x) => {

                 await axios.post(this.$apiSA31 + "soluciona31/get_informe_descargo/", {
                    'id': x,
                    'rfc': rfc
                })
                .then(response => {
                    this.registro = response.data;
                    plantas += this.registro.planta + " | ";
                    let destino = this.registro.cabecera.destino_aduanero;
                    let d = this.destinos_aduaneros.filter(item => {
                        return item.clave == destino
                    });
                    if (d.length > 0) {
                        this.registro.cabecera.destino_aduanero = d[0].clave + " = " + d[0].nombre;
                    }
                    let periodo = this.registro.cabecera.periodo_asociado;
                    let p = this.periodos.filter(item => {
                        return item.clave == periodo
                    });

                    if (p.length > 0) {
                        this.registro.cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                    }

                    detalles = detalles.concat(self.registro.detalles);
                    self.registro.detalles = detalles;
                    self.registro.planta = plantas;
                }).catch(error => {
                    console.log(error);

                });
                }));


                    console.log(plantas);
                    if(this.$refs.vuetable_d1 != undefined) {
                      this.$refs.vuetable_d1.resetQuery();
                    }
                    this.dialog = true;
                    self.$root.$dialogLoader.hide();

            }else{
                axios.post(this.$apiSA31 + "soluciona31/get_informe_descargo/", {
                    'id': row._id,
                    'rfc': rfc
                })
                .then(response => {
                    this.registro = response.data;

                    let destino = this.registro.cabecera.destino_aduanero;
                    let d = this.destinos_aduaneros.filter(item => {
                        return item.clave == destino
                    });
                    if (d.length > 0) {
                        this.registro.cabecera.destino_aduanero = d[0].clave + " = " + d[0].nombre;
                    }


                    let periodo = this.registro.cabecera.periodo_asociado;
                    let p = this.periodos.filter(item => {
                        return item.clave == periodo
                    });

                    if (p.length > 0) {
                        this.registro.cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                    }

                    if(this.$refs.vuetable_d1 != undefined) {
                      this.$refs.vuetable_d1.resetQuery();
                    }
                    this.dialog = true;

                })
                .catch(error => {
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                }).then(response => {
                    this.$root.$dialogLoader.hide();
                });
            }

        },
        getDetallesInicial: function (row) {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc");
            axios.post(this.$apiSA31 + "soluciona31/get_inventario_inicial/", {
                    'id': row._id,
                    'rfc': rfc
                })
                .then(response => {
                    this.registro2 = response.data;
                    this.registro2.fecha = moment(String(this.registro2.fecha)).format("YYYY-MM-DD");
                    this.registro2.reemplazo = row.reemplazo;

                    if(this.$refs.vuetable_d2 != undefined) {
                      this.$refs.vuetable_d2.resetQuery();
                    }

                    this.dialog2 = true;

                })
                .catch(error => {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                }).then(response => {
                    self.$root.$dialogLoader.hide();
                });
        },
        eliminar: function (row, tipo) {
            var self = this;
            self.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    var rfc = this.$local_storage.get("rfc");
                    if( Array.isArray(row._id)){

                 await  Promise.all(row._id.map(async (x) => {
                      await axios.post(self.$apiSA31 + "/soluciona31/eliminar_informe/", {
                            'id': x,
                            'rfc': rfc,
                            'tipo': 'descargo',
                            'usuario': self.$local_storage.get("email"),
                        })
                            .then(response => {

                            })
                            .catch(error => {

                            });
                    }));
                    self.getBitacora();
                    self.$root.$dialogLoader.hide();
                    self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "Los registros se eliminaron correctamente",
                                    footer: ""
                                });

                    }else{
                        axios.post(this.$apiSA31 + "/soluciona31/eliminar_informe/", {
                            'id': row._id,
                            'rfc': rfc,
                            'tipo': tipo,
                            'usuario': self.$local_storage.get("email"),
                        })
                        .then(response => {

                            self.$swal({
                                                    type: "success",
                                                    title: "Operación Exitosa",
                                                    text: "El archivo se eliminó correctamente",
                                                    footer: ""
                                                });
                                                if(tipo == 'descargo'){
                                                    self.getBitacora();
                                                }
                                                if(tipo == 'inventario'){
                                                    self.getInicial();
                                                }

                        })
                        .catch(error => {
                            self.$swal({
                                                    type: "error",
                                                    title: "Operación No Permitida",
                                                    text: "El archivo no puede ser eliminado",
                                                    footer: ""
                                                });
                        });
                    }

                        }else{
                            self.$root.$dialogLoader.hide();
                        }
            });

        },
        validar: function (row) {
            var self = this;
            self.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro que desea validar el informe?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var rfc = this.$local_storage.get("rfc");
                    if( Array.isArray(row._id)){
                        await  Promise.all(row._id.map(async (x) => {
                   // self.selecteds.forEach(function(x){

                       await axios.post(self.$apiSA31 + "/soluciona31/validar_detalles_descargo/", {
                            'id': x,
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("email")
                        })
                            .then(response => {

                            })
                            .catch(error => {

                            });
                    }));
                    self.getBitacora();
                    self.$root.$dialogLoader.hide();
                    self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "Los registros se validaron correctamente",
                                    footer: ""
                                });
                    }else{
                        axios.post(this.$apiSA31 + "/soluciona31/validar_detalles_descargo/", {
                            'id': row._id,
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("email")
                        })
                        .then(response => {

                            self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El archivo se valido correctamente",
                                    footer: ""
                                });
                              self.getBitacora();

                        })
                        .catch(error => {
                            self.$swal({
                                                    type: "error",
                                                    title: "Operación No Permitida",
                                                    text: "El archivo no puede ser validado",
                                                    footer: ""
                                                });
                        }).then(response => {

                            self.$root.$dialogLoader.hide();

                                });
                    }

                        }
            });

        },
        validarInicial: function (row) {
            var self = this;
            self.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro que desea validar el Inventario Inicial?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    var rfc = this.$local_storage.get("rfc");
                    self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                   await axios.post(this.$apiSA31 + "/soluciona31/revalidar_inventario_inicial/", {
                            'id': row._id,
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("email")
                        })
                        .then(response => {

                            self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El archivo se valido correctamente",
                                    footer: ""
                                });


                        })
                        .catch(error => {
                            self.$swal({
                                                    type: "error",
                                                    title: "Operación No Permitida",
                                                    text: "El archivo no puede ser validado",
                                                    footer: ""
                                                });
                        }).then(response => {

                            self.$root.$dialogLoader.hide();

                                });
                        }
            });

        },
        formatNumber: function (numero, decimales) {
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)) {
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        download_layout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        to_currency_decimal: function(x) {
          let cr = 'USD';

          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: cr,
            minimumFractionDigits: 2,
          })

          return formatter.format(x);
        },
        downloadFile: function (nombre) {

            //alert(nombre);
            var datos = {
                id: nombre,
                bucket: "production.econnect.ds"
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        eliminar_adjunto: function(id) {
          this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro que desea eliminar la imagen?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
            axios.post(this.$apiSA31 + "/soluciona31/eliminar_adjunto_informe/", {'id': id})
            .then(response => {
              this.getBitacora();
              this.$swal({
                  type: "success",
                  title: "¡Operación exitosa!",
                  text: '',
                  footer: '',
              });
            }).catch(error => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: '',
                  footer: '',
              });
            });
          });
        },
        download_xlsx: function (folio) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var name = "Detalles_Inventario_Inicial.xlsx";
            var items = [];
    
            this.registro2.detalles.forEach((item) => {
                    
                items.push({
                    'Folio': folio,
                    'Tipo Informe':  item['tipo_infome'] ,
                    'Aduana' : item['aduana'],
                    'Patente':  item['patente'],
                    'Pedimento':  item['pedimento'],
                    'Fecha Entrada':   item['fecha_entrada'],
                    'Fracción Arancelaria':   item['fraccion_arancelaria'],
                    'Valor Comercial':  item['valor_comercial'],
                    'Identificador':  item['identificador'] ,
                    'Informe a Sustituir':   item['folio'],
                    'Indicador Verificado':   item['errores'],
                });
            
            });
    
            const worksheet = XLSX.utils.json_to_sheet(items);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Inventario Inicial");
            XLSX.writeFile(workbook, name, { compression: true });

            this.$root.$dialogLoader.hide();
        },
        download_xlsx_descargo: function (folio) {
        
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var name = "Detalles_Informe_Descargo.xlsx";
            var items = [];
    
            this.registro.detalles.forEach((item) => {
                    
                items.push({
                    'Folio': folio,
                    'Tipo Informe':  item['tipo_infome'] ,
                    'Aduana' : item['aduana'],
                    'Patente':  item['patente'],
                    'Pedimento':  item['pedimento'],
                    'Fecha Entrada':   item['fecha_entrada'],
                    'Fracción Arancelaria':   item['fraccion_arancelaria'],
                    'Valor Comercial':  item['valor_comercial'],
                    'Identificador':  item['identificador'] ,
                    'Informe a Sustituir':   item['folio'],
                    'Indicador Verificado':   item['errores'],
                    'Planta':   item['planta'],
                });
            
            });
    
            const worksheet = XLSX.utils.json_to_sheet(items);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Informe Descargo");
            XLSX.writeFile(workbook, name, { compression: true });

            this.$root.$dialogLoader.hide();
        }
    },
    computed: {
        datafiltered1() {
            let self = this;
            let result = [];
            if (this.$refs.vuetable1 != null) {
                result = this.$refs.vuetable1.allFilteredData;
                return result;
            } else {
                result = this.bitacora.items_inicial;
                return result;
            }
        },
        datafiltered2() {
            let self = this;
            let result = [];
            self.selecteds = [];
            self.selecteds_acomodados= [];
            this.total_cargos_calculado = 0;
            this.total_cargos_final = 0;
            if (this.$refs.vuetable2 != null) {
                result = this.$refs.vuetable2.allFilteredData;
                result.forEach((it) => {
                  this.total_cargos_final +=it.valor_comercial_final;
                  this.total_cargos_calculado +=it.valor_comercial_calculado;
                });

                     if( self.allChecked ){
                        let arr = self.allChecked ? result.map(row =>  row._id) : [];

                        if (arr.length > 0) {
                            for (var i = 0; i < arr.length; i++) {
                            if (self.selecteds.includes(arr[i])) {
                                continue;
                            } else {
                                self.selecteds.push(arr[i]);
                            }
                            }
                        }
                        self.acomoda_selecteds();

                }

                return result;
            } else {
                result = this.bitacora.items;
                result.forEach((it) => {
                  this.total_cargos_calculado +=it.valor_comercial_calculado;
                  this.total_cargos_final +=it.valor_comercial_final;
                });
                if( self.allChecked ){
                        let arr = self.allChecked ? result.map(row =>  row._id) : [];

                        if (arr.length > 0) {
                            for (var i = 0; i < arr.length; i++) {
                            if (self.selecteds.includes(arr[i])) {
                                continue;
                            } else {
                                self.selecteds.push(arr[i]);
                            }
                            }
                        }
                        self.acomoda_selecteds();
                    }
                return result;
            }
        },
        planta_referencia() {
            return  this.$local_storage.get("Modulo16") == 100 ;
        },
        datafiltered() {
            let self = this;
            let result = [];
            if (this.$refs.vuetable != null) {
                result = this.$refs.vuetable.allFilteredData;
                return result;
            } else {
                result = this.data_view.datos;
                return result;
            }
        },



    },
    mounted: function () {

        this.getPeriodos();
        this.cargarPlantas();
        document.getElementsByName("vf__estatus")[0].options[0].remove();

    },
};
</script>

<style scoped>
.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

.text-number {
    text-align: right;
}
.VueTables>>>thead th {
  white-space: normal !important;
  text-align: center !important;
}

div > #ck_folio{
  position: relative !important;
}

@media (max-width:1920px) {
  .VueTables>>>tbody td {
    font-size: 0.75rem;
      padding: 0.5rem;
  }

  .VueTables>>>thead th .form-control{
    font-size: 0.75rem !important;
  }

  .VueTables>>>thead th {
    white-space: normal !important;
    text-align: center !important;
    font-size: 0.75rem;
    padding: 0.5rem;
  }
}

</style>
